// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.0faf11e81.chunk.js";
	if (chunkId === 12) return "static/js/profiler.0faf11e81.chunk.js";
	if (chunkId === 502) return "static/js/502.0faf11e81.chunk.js";
	if (chunkId === 747) return "static/js/747.0faf11e81.chunk.js";
	if (chunkId === 246) return "static/js/246.0faf11e81.chunk.js";
	if (chunkId === 506) return "static/js/506.0faf11e81.chunk.js";
	if (chunkId === 420) return "static/js/420.0faf11e81.chunk.js";
	if (chunkId === 854) return "static/js/854.0faf11e81.chunk.js";
	if (chunkId === 725) return "static/js/725.0faf11e81.chunk.js";
	if (chunkId === 240) return "static/js/240.0faf11e81.chunk.js";
	if (chunkId === 916) return "static/js/916.0faf11e81.chunk.js";
	// return url for filenames based on template
	return undefined;
};